// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Eh1J","containerItemsCenter":"Skeleton_containerItemsCenter__2q_br"};